import { isImageLoaded } from './selectors'
/* ***************************** Action Types ****************************** */
const actionTypes = {
  addImage: 'addImageAction',
  deleteImage: 'deleteImageAction',
  markImageAsLoaded: 'markImageAsLoadedAction',
  resetImages: 'resetGalleryImagesAction',
}
export default actionTypes
/* ******************************** Actions ******************************** */
export const addImageAction = (imageSource) => ({
  type: actionTypes.addImage,
  url: imageSource,
})
export const deleteImageAction = (imageSource) => ({
  type: actionTypes.deleteImage,
  url: imageSource,
})
export const resetGalleryImagesAction = () => ({
  type: actionTypes.resetImages,
})
/* **************************** Private Actions **************************** */
/* These actions should not be called directly by components.
 * They are used by asynchronous actions.
 */
export const markImageAsLoadedAction = (imageSource) => ({
  type: actionTypes.markImageAsLoaded,
  url: imageSource,
})
/* **************************** Async Actions ****************************** */
export const setupImageAction = (imageSource) => (dispatch, getState) => {
  if (!isImageLoaded(getState(), { src: imageSource })) {
    dispatch(markImageAsLoadedAction(imageSource))
  }
}



// WEBPACK FOOTER //
// ./src/asyncImages/actions.js